import styles from './trainer-icon.module.scss'
import { Trainer } from '../../dao/core-dao'
import { fileService } from '../../service/file-service'
import React from 'react'

export const TrainerIcon = (props: { trainer: Trainer; active: boolean }): React.ReactElement => {
  const { trainer, active } = props

  return (
    <div className={styles.container}>
      <img
        className={styles.image}
        src={fileService.publicUrlFromFileId(trainer.mediumProfilePhotoPublicFileId)}
        alt={trainer.firstName}
      />
      <div className={`${styles.imageContainer} ${active ? 'active' : ''}`} />
      <p
        className={`font-evogria text-xs leading-4 tracking-[0.5px] text-light-gray mt-[5px] text-center mb-0 ${
          active ? 'active' : ''
        }`}
      >
        {trainer.firstName}
      </p>
    </div>
  )
}
